import React from 'react'
import styles from './AudioTabContent.module.scss'
import {AudioSlider} from './AudioSlider.tsx'
import {T} from '@colonist/ui'
import {useGameUserSettingsSetVolume} from '../../../hooks/useGameUserSettingsVolume.ts'
import {useGameStore} from '../../../store/GameStoreContext.ts'

export const AudioTabContent = () => {
    const volume = useGameStore((state) => state.gameUserSettings.volume)
    const isMuted = useGameStore((state) => state.gameUserSettings.isMuted)
    const setVolume = useGameUserSettingsSetVolume()
    const displayVolume = isMuted ? 0 : volume

    return <div className={styles.container}>
        <div className={styles.heading}><T id='strings:game.settings.audioTab.volume'/></div>
        <div className={styles.volumeContainer}>
            <div className={styles.volumeText}>{(displayVolume * 100).toFixed(0)}</div>
            <div className={styles.volumeSlider}>
                <AudioSlider onChange={setVolume} value={displayVolume}/>
            </div>
        </div>
    </div>
}
